<div style="height: 100%;">
    <form style="height: 100%;">
        <div style="height: 10%;background-color: rgb(63,81,181);color: rgba(255,255,255,0.87);">
            <h2 class="headerName">Review</h2>
        </div>

        <div style="height: 80%; padding: 1%;overflow: auto;">
            <div style="height: 50%;width: 100%;">
                <div style="text-align: center;">
                    <h2 class="headerName" style="color: black;">Customer Rating</h2>
                </div>
                <div style="text-align: center;">
                    <ngb-rating [readonly]="false" [max]=5 [(rate)]="ratingCustomerType" (rateChange)="ratingClick()"
                        required>
                    </ngb-rating>
                </div>
            </div>
            <div style="height: 50%;width: 100%;">
                <div style="text-align: center;">
                    <h2 class="headerName" style="color: black;">Location Rating</h2>
                </div>
                <div style="text-align: center;">
                    <ngb-rating [readonly]="false" [max]=5 [(rate)]="ratingLocationType" (rateChange)="ratingClick()"
                        required>
                    </ngb-rating>
                </div>
            </div>
        </div>

        <div class="div_btn_rt">
            <button *ngIf="isShowSubmit" type="button" id="shipping_btn_rt" (click)="saveClick()">
                Submit
            </button>
        </div>
    </form>
</div>